export default {
    "signup_troublesigningup": "無法註冊嗎？",
    "readandagree": "註冊/登入即表示您已閱讀並同意"
}